import React, { Fragment, useEffect, useState } from 'react';
import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import './../Resources/css/block_about.css';

import { TextHeader, TextTitle, TextBock } from '../../../Controls/Digital/TextHeaders';

const About = (props) =>{

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (
        <Block name="about" isAlt={true}>

            <TextHeader text={
                <Fragment>
                    Meet Rico
                </Fragment>
            } />

            <TextTitle text={
                <Fragment>
                    Meet Rico
                </Fragment>
            } />

            
        </Block>
    );
}
export default About;
